import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    // event.preventDefault();
  }
  // Désactiver les raccourcis pour la console en mode production
  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // if (event.keyCode === 123 || (event.ctrlKey && event.shiftKey && event.keyCode === 73)) {
    //   event.preventDefault();
    // }
  }
  title = 'bi.jant.tech.angular';

  constructor(private config: NgSelectConfig) {

    this.config.notFoundText = 'Aucun résultat';
    this.config.appendTo = 'body';
    // this.config.placeholder="Rechercher / Filtrer"
    this.config.disableVirtualScroll=false
    // set the bindValue to global config when you use the same
    // bindValue in most of the place.
    // You can also override bindValue for the specified template
    // by defining `bindValue` as property
    // Eg : <ng-select bindValue="some-new-value"></ng-select>
    // this.config.bindValue = 'value';
  }
}
